import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  //return Cookies.get(TokenKey)
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  //return Cookies.set(TokenKey, token)
  return window.localStorage.setItem(TokenKey,token)

}

export function removeToken() {
  console.log(1111111)
  //return Cookies.remove(TokenKey)
  return localStorage.removeItem(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js